import { jsx as _jsx } from "react/jsx-runtime";
import { useResponsiveContext } from '../utils/ResponsiveContext';
import AppService from '../utils/AppService';
export function FooterLogo() {
    var _a = useResponsiveContext(), isMobile = _a.isMobile, isDesktop = _a.isDesktop, isLargeDesktop = _a.isLargeDesktop;
    var logoAlt = 'アペルザ(Apérza)';
    var logoSrc = "".concat(AppService.staticServerHost(), "/common/images/aperza2022/red/logo_yoko.svg");
    // mobile
    if (isMobile) {
        return _jsx("img", { alt: logoAlt, src: logoSrc, width: 157, height: 35 });
    }
    // mid Desktop
    if (isDesktop && !isLargeDesktop) {
        return _jsx("img", { alt: logoAlt, src: logoSrc, width: 174, height: 39 });
    }
    // large Desktop
    return _jsx("img", { alt: logoAlt, src: logoSrc, width: 192, height: 43 });
}
